import type { Middleware } from '@reduxjs/toolkit';
import { isRejectedWithValue, isRejected } from '@reduxjs/toolkit';
import { getResponseError } from '../utils/getResponseError';
import { enqueueSnackbar } from 'notistack';

export const rtkQueryErrorLogger: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const error = action.payload;
    enqueueSnackbar(getResponseError(error));
  } else if (isRejected(action)) {
    const error = action.error;
    enqueueSnackbar(getResponseError(error));
  }

  return next(action);
};
